/**
 * TABLE TOKENS
 *
 * Custom additions are marked with "Custom" comments below.
 */
import { nbxVar as v } from '../../../tokens/generated/nbx-tokens.js';
import { SEMANTIC, type SemanticTokens } from '../semantic.js';

export function createTableTokens(s: SemanticTokens) {
  return {
    headerBg: v('table.header-bg'), // --table-header-bg: Text/secondary ink #08183a
    rowBg: s.surface.ground, // --table-row-bg: var(--surface-ground)
    rowBgHover: s.surface.ground, // --table-row-bg-hover: var(--surface-ground)
    rowBgSelected: s.border.divider, // --table-row-bg-selected: var(--border-divider)
    tableBorder: s.border.divider, // --table-table-border: var(--border-divider)

    // ──── Custom tokens ────

    radius: s.radius.md, // --table-radius: var(--radius-8)
    fontFamily: s.typography.fontFamily.base, // --table-font-family
    transitionDuration: s.transition.normal, // --table-transition-duration
    headerFontSize: s.typography.fontSize.sm, // --table-header-font-size
    headerFontWeight: s.typography.fontWeight.semibold, // --table-header-font-weight
    headerLineHeight: s.typography.lineHeight.lg, // --table-header-line-height
    bodyFontSize: s.typography.fontSize.base, // --table-body-font-size
    bodyFontWeight: s.typography.fontWeight.normal, // --table-body-font-weight
    bodyLineHeight: s.typography.lineHeight.xl, // --table-body-line-height
    bodySemiboldWeight: s.typography.fontWeight.semibold, // --table-body-semibold-weight
    padding: s.layout.gap.md, // --table-padding
    headerPadding: `calc(${s.layout.gap.md} - 2px) ${s.layout.gap.md}`, // --table-header-padding: 14px 16px, a 48px header row
    sortIconSize: s.typography.fontSize.base, // --table-sort-icon-size
    loadingIconSize: s.iconSizes.lg, // --table-loading-icon-size
    rowToggleSize: '1.75rem', // --table-row-toggle-size
    rowToggleRadius: '50%', // --table-row-toggle-radius
    columnTitleFontWeight: s.typography.fontWeight.semibold, // --table-column-title-font-weight
    footerFontWeight: s.typography.fontWeight.semibold, // --table-footer-font-weight
    headerFg: s.text.onColor, // --table-header-fg: var(--text-on-color)
    headerBgHover: s.text.muted, // --table-header-bg-hover: var(--text-muted)
    rowFg: s.text.secondary, // --table-row-fg: var(--text-secondary)
    rowFgHover: s.text.secondary, // --table-row-fg-hover: var(--text-secondary)
    rowFgSelected: s.text.primary, // --table-row-fg-selected: var(--text-primary)
    stripedBg: s.surface.canvas, // --table-row-striped-bg: var(--surface-canvas)
    footerBg: s.surface.ground, // --table-footer-bg: var(--surface-ground)
    footerFg: s.text.secondary, // --table-footer-fg: var(--text-secondary)
    footerBorder: s.border.divider, // --table-footer-border: var(--border-divider)
    sortIconFg: s.text.onColor, // --table-sort-icon-fg: var(--text-on-color)
    dropPointFg: s.interactive.primary.base, // --table-drop-point-fg
    resizeIndicatorFg: s.interactive.primary.base, // --table-resize-indicator-fg
    rowToggle: {
      bgHover: s.surface.canvas, // --table-row-toggle-bg-hover
      fg: s.text.muted, // --table-row-toggle-fg
      fgHover: s.text.secondary, // --table-row-toggle-fg-hover
      bgSelectedHover: s.interactive.primary.base, // --table-row-toggle-bg-selected-hover
      fgSelectedHover: s.text.onColor, // --table-row-toggle-fg-selected-hover
    },
  };
}
export const tableTokens = createTableTokens(SEMANTIC);
